import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import Login from '../routes/Login';
import { peekReturnTo, setReturnTo } from '../utilities/return-to';

type ProtectedRouteProps = {
  children: ReactElement;
  requireLoggedIn?: boolean;
  requireAdmin?: boolean;
  redirectPath?: string;
};

export function ProtectedRoute({
  children,
  requireLoggedIn,
  requireAdmin,
  redirectPath,
}: ProtectedRouteProps): ReactElement {
  const { loggedIn, databaseUser: user } = useAuth();
  const location = useLocation();

  if (loggedIn === null) {
    return <Login />;
  }

  if (
    loggedIn === !!requireLoggedIn &&
    (requireAdmin === undefined || user?.admin === requireAdmin)
  ) {
    return children;
  }

  // Someone who isn't logged in comes back here after logging in, and
  // someone who just logged in goes back where they came from
  if (requireLoggedIn && !loggedIn) {
    setReturnTo(`${location.pathname}${location.search}`);
  }
  const target = !requireLoggedIn && loggedIn ? peekReturnTo() : null;

  return <Navigate to={target ?? redirectPath ?? '/'} />;
}
